import { getRevenue, getMCIReports, getPolicyReports, getGoodsReports, getSalesReports, 
    getMapReports, getMapGeoJSON, getRevenueReports } from '../utils/apiService';

export const GET_REVENUES = 'reports/GET_REVENUES';
export const GET_REVENUES_PENDING = 'reports/GET_REVENUES_PENDING';
export const GET_REVENUES_REJECTED = 'reports/GET_REVENUES_REJECTED';
export const GET_REVENUES_FULFILLED = 'reports/GET_REVENUES_FULFILLED';

export const GET_REVENUE_REPORTS = 'reports/GET_REVENUE_REPORTS';
export const GET_REVENUE_REPORTS_PENDING = 'reports/GET_REVENUE_REPORTS_PENDING';
export const GET_REVENUE_REPORTS_REJECTED = 'reports/GET_REVENUE_REPORTS_REJECTED';
export const GET_REVENUE_REPORTS_FULFILLED = 'reports/GET_REVENUE_REPORTS_FULFILLED';

export const GET_MCI_REPORTS = 'reports/GET_MCI_REPORTS';
export const GET_MCI_REPORTS_PENDING = 'reports/GET_MCI_REPORTS_PENDING';
export const GET_MCI_REPORTS_REJECTED = 'reports/GET_MCI_REPORTS_REJECTED';
export const GET_MCI_REPORTS_FULFILLED = 'reports/GET_MCI_REPORTS_FULFILLED';

export const GET_POLICY_REPORTS = 'reports/GET_POLICY_REPORTS';
export const GET_POLICY_REPORTS_PENDING = 'reports/GET_POLICY_REPORTS_PENDING';
export const GET_POLICY_REPORTS_REJECTED = 'reports/GET_POLICY_REPORTS_REJECTED';
export const GET_POLICY_REPORTS_FULFILLED = 'reports/GET_POLICY_REPORTS_FULFILLED';

export const GET_GOODS_REPORTS = 'reports/GET_GOODS_REPORTS';
export const GET_GOODS_REPORTS_PENDING = 'reports/GET_GOODS_REPORTS_PENDING';
export const GET_GOODS_REPORTS_REJECTED = 'reports/GET_GOODS_REPORTS_REJECTED';
export const GET_GOODS_REPORTS_FULFILLED = 'reports/GET_GOODS_REPORTS_FULFILLED';

export const GET_SALES_REPORTS = 'reports/GET_SALES_REPORTS';
export const GET_SALES_REPORTS_PENDING = 'reports/GET_SALES_REPORTS_PENDING';
export const GET_SALES_REPORTS_REJECTED = 'reports/GET_SALES_REPORTS_REJECTED';
export const GET_SALES_REPORTS_FULFILLED = 'reports/GET_SALES_REPORTS_FULFILLED';

export const GET_MAP_POLICY_REPORTS = 'reports/GET_MAP_POLICY_REPORTS';
export const GET_MAP_POLICY_REPORTS_PENDING = 'reports/GET_MAP_POLICY_REPORTS_PENDING';
export const GET_MAP_POLICY_REPORTS_REJECTED = 'reports/GET_MAP_POLICY_REPORTS_REJECTED';
export const GET_MAP_POLICY_REPORTS_FULFILLED = 'reports/GET_MAP_POLICY_REPORTS_FULFILLED';

export const GET_WORLD_GEOJSON = 'reports/GET_WORLD_GEOJSON';
export const GET_WORLD_GEOJSON_PENDING = 'reports/GET_WORLD_GEOJSON_PENDING';
export const GET_WORLD_GEOJSON_REJECTED = 'reports/GET_WORLD_GEOJSON_REJECTED';
export const GET_WORLD_GEOJSON_FULFILLED = 'reports/GET_WORLD_GEOJSON_FULFILLED';

export const listRevenue = () =>{
    return {
        type: GET_REVENUES,
        payload: getRevenue()
    }
}

export const loadRevenueReports = (date_range) => {
    return{
        type: GET_REVENUE_REPORTS,
        payload: getRevenueReports(date_range)
    }
}

export const loadMCIReports = (filter, date_range) => {
    return{
        type: GET_MCI_REPORTS,
        payload: getMCIReports(filter, date_range)
    }
}

export const loadPolicyReports = (filter, date_range) => {
    return{
        type: GET_POLICY_REPORTS,
        payload: getPolicyReports(filter, date_range)
    }
}

export const loadGoodsReports = (date_range) => {
    return{
        type: GET_GOODS_REPORTS,
        payload: getGoodsReports(date_range)
    }
}

export const loadSalesReports = (filter, date_range) => {
    return{
        type: GET_SALES_REPORTS,
        payload: getSalesReports(filter, date_range)
    }
}

export const loadMapReports = () => {
    return{
        type: GET_MAP_POLICY_REPORTS,
        payload: getMapReports()
    }
}

export const loadMapGeoJSON = () => {
    return{
        type: GET_WORLD_GEOJSON,
        payload: getMapGeoJSON()
    }
}



// WEBPACK FOOTER //
// ./src/actions/reports.js